// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"close-button_ko-KR__5B_PX","impressionTrackingContainer":"close-button_impressionTrackingContainer__2svnB","closeButton":"close-button_closeButton__SpRhh"};